/* eslint-disable dot-notation */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-return */
import { Button, Grid, IconButton, TextField, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { cloneDeep, omit } from 'lodash';

import { gameBookTemplateActions, gameVariablesTemplateActions } from '@orientaction/api-actions';
import { deleteVideoByUrl, uploadVideo } from '@orientaction/components/Admin/VideoImport';
import { gameBookValues, gameVariables, gameVariableValues } from '@orientaction/reducers';
import {
  DragListRestitution,
  ItemAddRestitution,
  Layout,
  Modal,
  ModelVariable1,
  ModelVariable2,
  ModelVariable3,
  ModelVariable4,
  ModelVariable5,
  ModelVariable6,
  ModelVariable7,
  SimpleModal,
} from '@orientaction/components';
import { ReactComponent as Border } from '../../../Asset/svg/border.svg';
import { ReactComponent as Move } from '../../../Asset/svg/move.svg';
import { ReactComponent as Save } from '../../../Asset/svg/save.svg';
import { ReactComponent as Browser } from '../../../Asset/svg/browser.svg';

import style from '../style';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import { ReactComponent as Delete } from '../../../Asset/svg/delete.svg';
import { apiServiceNative } from '../../../utils/fetchNative';
import Loader from '../EditPage/loader-edit';
import ModalEditGame from '../EditPage/modal-edit-game';

const EditVariable = () => {
  const classes = style();
  const dispatch = useDispatch();
  const allVariables = useSelector(gameVariables);
  const valuesVariables = useSelector(gameVariableValues);
  const valuesBooksTemplate = useSelector(gameBookValues);
  const [isEditTitle, setIsEditTitle] = useState<boolean>(false);
  const [title, setTitle] = useState<string>('');
  const [pageRestitution, setPageRestitution] = useState<any[]>([]);
  const [currentPageIndex, setCurrentPageIndex] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<any>(null);
  const refInput = useRef(null);
  const [openModalCancel, setOpenModalCancel] = useState<boolean>(false);
  const { edit, id }: any = useParams();
  const indexPageRestitutionNumber = parseInt(sessionStorage.getItem('addRestitutionPagePosition') || '0', 10);
  const history = useHistory();
  const pageRestitutionNotChanged = [...valuesVariables?.page_restore];
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [textLoading, setTextLoading] = useState<string>('');
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [openPublishModal, setOpenPublishModal] = useState<boolean>(false);
  const [openExitModal, setOpenExitModal] = useState<boolean>(false);
  console.log({pageRestitutionNotChanged});

  const handleButtonClick = (index: number) => {
    setActiveIndex(index);
  };

  const getGameData = () => {
    const pagesRaw = sessionStorage.getItem('gamePages');
    const variablesRaw = sessionStorage.getItem('gameVariables');
    const pages = pagesRaw ? JSON.parse(pagesRaw) : valuesBooksTemplate?.pages || [];
    const currentVariables = variablesRaw ? JSON.parse(variablesRaw) : allVariables || [];
    const variablesWithCurrentRestitution = [...currentVariables];
    if (variablesWithCurrentRestitution[id] && valuesVariables?.page_restitution) {
      variablesWithCurrentRestitution[id] = {
        ...variablesWithCurrentRestitution[id],
        ...valuesVariables,
        page_restitution: valuesVariables.page_restitution,
      };
    }
    return {
      ...valuesBooksTemplate,
      pages,
      variables_restitution: variablesWithCurrentRestitution,
    };
  };

  const removePagesField = (array: any) =>
    array.map((obj: any) => {
      const { pages, videoFile, videoToDelete, ...rest } = obj;
      return rest;
    });

  const removeStringIds = (array: any) =>
    array.map((item: any) => {
      if (typeof item?.id === 'string') {
        delete item?.id;
      }
      return item;
    });

  const stripVideoSaveMetadata = (page: any) => {
    const { videoFile, videoToDelete, ...pageWithoutVideoSaveMetadata } = page;
    return pageWithoutVideoSaveMetadata;
  };

  const uploadPendingRestitutionVideos = async (variables: any[] = []) => {
    const uploadedUrls: string[] = [];
    const variablesToSave = await Promise.all(
      variables.map(async (variable: any) => {
        const preparedPages = await Promise.all(
          (variable?.page_restitution || []).map(async (page: any) => {
            if (!page?.videoFile) {
              return stripVideoSaveMetadata(page);
            }

            const uploadedUrl = await uploadVideo(page.videoFile);
            uploadedUrls.push(uploadedUrl);
            return {
              ...stripVideoSaveMetadata(page),
              video: uploadedUrl,
            };
          })
        );

        return {
          ...variable,
          page_restitution: preparedPages,
        };
      })
    );

    return { variablesToSave, uploadedUrls };
  };

  const getDeletedRestitutionVideoUrls = (variables: any[] = []) =>
    variables.flatMap((variable: any) =>
      (variable?.page_restitution || [])
        .map((page: any) => page?.videoToDelete)
        .filter(Boolean)
    );

  const buildFormData = (gameData: any) => {
    const payload = removePagesField(gameData.pages);
    const formData = new FormData();

    gameData.pages.forEach((page: any, index: any) => {
      if (page.files) {
        formData.append(`file.img${index}`, page.files);
      }
    });
    formData.append('createdFrom', 'front_user');
    const gameTitle = gameData?.titlGame || gameData?.title || valuesBooksTemplate?.titlGame;
    if (gameTitle) {
      formData.append('title', gameTitle);
    }
    if (valuesBooksTemplate?.['file.img']) {
      formData.append('file.img', valuesBooksTemplate['file.img']);
    }
    formData.append('pagesList', JSON.stringify(removeStringIds(payload)));
    formData.append(
      'variables_restitution',
      JSON.stringify(gameData?.variables_restitution?.length > 0 ? gameData.variables_restitution : [])
    );
    formData.append('typeGame', gameData?.typeGame || 'classic');
    return formData;
  };

  const updateGame = async (idx: any, formData: any) => {
    const response = await apiServiceNative.put(`/api/update-game/${idx}`, formData, true);
    return response;
  };

  const updateCouve = async (idx: any, formData: any) => {
    sessionStorage.setItem('id', idx);
    await apiServiceNative.put(`/api/update-game-cover/${idx}`, formData, true);
  };

  const updateGameStatus = async (idX: any, isPublish: any) => {
    await apiServiceNative.put(`/api/change-status-game/${idX}`, {
      publishedAt: !!isPublish,
    });
  };

  const handleSaveGame = async (isPublish?: boolean) => {
    setLoading(true);
    const uploadedUrls: string[] = [];

    try {
      setTextLoading('Téléversement des vidéos en cours ...');
      const gameData = getGameData();
      const preparedRestitution = await uploadPendingRestitutionVideos(gameData.variables_restitution);
      uploadedUrls.push(...preparedRestitution.uploadedUrls);
      const gameDataToSave = {
        ...gameData,
        variables_restitution: preparedRestitution.variablesToSave,
      };
      const deletedVideoUrls = getDeletedRestitutionVideoUrls(gameData.variables_restitution);
      const formData = buildFormData(gameDataToSave);
      setTextLoading(isPublish ? 'Publication en cours ...' : 'Sauvegarde en cours ...');
      let response;
      const gameId = sessionStorage.getItem('id');

      if (gameId) {
        await updateGameStatus(gameId, isPublish);
        await updateCouve(gameId, formData);
        response = await updateGame(gameId, formData);
      } else {
        const idsPages = gameDataToSave.pages.map((res: any) => res.id);
        const idsPagesString = idsPages.join(',');
        const idsVariables = gameDataToSave.variables_restitution?.map((res: any) => res.id) || [];
        const idsVariablesString = idsVariables.join(',');
        const idNews = await apiServiceNative.get(
          idsVariables.length > 0
            ? `/api/get-id-game?pageId=${idsPagesString}&variableIds=${idsVariablesString}`
            : `/api/get-id-game?pageId=${idsPagesString}`
        );
        await updateCouve(idNews, formData);
        response = await updateGame(idNews, formData);
        if (isPublish) {
          await updateGameStatus(idNews, isPublish);
        }
      }

      if (response) {
        await Promise.allSettled(deletedVideoUrls.map((url: string) => deleteVideoByUrl(url)));
        dispatch(
          gameBookTemplateActions.updateField('variables_restitution', response?.variables_restitution)
        );
        dispatch(gameVariablesTemplateActions.setAllVariables(response?.variables_restitution || []));
        const savedVariable = response?.variables_restitution?.[id];
        if (savedVariable?.page_restitution) {
          dispatch(gameVariablesTemplateActions.setPageRestitution(savedVariable.page_restitution));
          setPageRestitution(savedVariable.page_restitution);
          setCurrentPage(savedVariable.page_restitution[currentPageIndex]);
        }
        if (response.id) {
          sessionStorage.setItem('id', response.id);
        }
        sessionStorage.removeItem('idPagesTemps');
        localStorage.removeItem('idFILESTemps');
        sessionStorage.removeItem('idVariablesTemps');
        sessionStorage.setItem('gamePages', JSON.stringify(response?.pages));
        sessionStorage.setItem('gameVariables', JSON.stringify(response?.variables_restitution));
      }
    } catch (err) {
      await Promise.allSettled(uploadedUrls.map(url => deleteVideoByUrl(url)));
      console.error('Erreur lors de la sauvegarde du jeu :', err);
    } finally {
      setLoading(false);
      setActiveIndex(null);
    }
  };

  const handleCloseModal = () => {
    setOpenPublishModal(false);
    setOpenExitModal(false);
    setActiveIndex(null);
  };

  const handleConfirmModal = () => {
    setActiveIndex(null);
    if (openExitModal) {
      setOpenExitModal(false);
      history.push('/admin/game/list');
    } else {
      handleSaveGame(true);
      setOpenPublishModal(false);
    }
  };

  const handleCancelModal = () => {
    setOpenPublishModal(false);
    setOpenExitModal(false);
    setActiveIndex(null);
  };

  // Charger les pages de restitution au montage initial()
  useEffect(() => {
    if (valuesVariables?.page_restitution && valuesVariables.page_restitution.length > 0) {
      setPageRestitution(valuesVariables.page_restitution);
    }
  }, []);

  useEffect(() => {
    setCurrentPage(valuesVariables.page_restitution[indexPageRestitutionNumber]);
    setCurrentPageIndex(indexPageRestitutionNumber);
    setTitle(valuesVariables.page_restitution[indexPageRestitutionNumber]?.title || '');
  }, [indexPageRestitutionNumber]);

  useEffect(() => {
    const refI: any = refInput?.current;
    if (isEditTitle && refI) {
      refI.click();
    }
  }, [isEditTitle]);
  

  const renderModelCondition = (page: any) => {
    if (!page || !page.template_game) return null;

    const props = { indexVariable: page.id, indexPageRestitutionNumber: currentPageIndex, isLastPage: pageRestitution?.length === currentPageIndex + 1 };

    switch (page.template_game) {
      case 1:
        return <ModelVariable1 {...props} />;
      case 2:
        return <ModelVariable2 {...props} />;
      case 3:
        return <ModelVariable3 {...props} />;
      case 4:
        return <ModelVariable4 {...props} />;
      case 5:
        return <ModelVariable5 {...props} />;
      case 6:
        return <ModelVariable6 {...props} />;
      case 7:
        return <ModelVariable7 {...props} />;
      default:
        return null;
    }
  };

  // Navigation vers une page spécifique
  const handlePageSelect = (page: any, index?: number) => {
    setCurrentPage(page);
    setCurrentPageIndex(index || 0);
    setTitle(page?.title || '');
    // dispatch(gameVariablesTemplateActions.setAllValuesModel(page));
  };

  // Gérer le réordonnancement des pages
  const handleReorderPages = (reorderedPages: any[], newIndex: number) => {
    setCurrentPageIndex(newIndex);
    setCurrentPage(reorderedPages[newIndex]);
    setTitle(reorderedPages[newIndex]?.title || '');
    setPageRestitution(reorderedPages);
    dispatch(gameVariablesTemplateActions.setPageRestitution(reorderedPages));
  };

  const handleSubmit = () => {
    const newVariables = cloneDeep([...allVariables]);
    newVariables[id].page_restitution = valuesVariables?.page_restitution || pageRestitution;
    dispatch(gameVariablesTemplateActions.setAllVariables(newVariables));
    dispatch(gameVariablesTemplateActions.resetValuesModel());
    confirmCancel();
    sessionStorage.removeItem('addRestitutionPagePosition');
  };

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      setIsEditTitle(false);
      // Mettre à jour le titre dans la page courante
      const updatedPages = cloneDeep(pageRestitution);
      if (updatedPages[currentPageIndex]) {
        updatedPages[currentPageIndex].title = title;
        setPageRestitution(updatedPages);
      }
    }
  };

  const confirmCancel = () => {
    if (!edit) {
      history.push('/admin/game/create-variables');
    } else {
      history.push('/admin/game/create-variables/edit');
    }
  };

  const handleTitleChange = (value: string) => {
    const pageRestArray = cloneDeep(valuesVariables.page_restitution);
    setTitle(value);
    pageRestArray[currentPageIndex]['title'] = value;
    valuesVariables.page_restitution = pageRestArray;
    setPageRestitution(pageRestArray);
    dispatch(gameVariablesTemplateActions.setPageRestitution(pageRestArray));
  };

  const handleKeyDownT = (event: any) => {
    if (event.key === 'Enter') {
      setIsEditTitle(false);
      const pageRestArray = cloneDeep(valuesVariables.page_restitution);
      pageRestArray[currentPageIndex]['title'] = title;
      valuesVariables.page_restitution = pageRestArray;
      setPageRestitution(pageRestArray);
      dispatch(gameVariablesTemplateActions.setPageRestitution(pageRestArray));
    }
  };

  const maxPages = parseInt(pageRestitution?.length as any || 0, 10);

  const moveUp = () => {
    if (currentPageIndex === 0) return;
    const newPages = [...pageRestitution];
    [newPages[currentPageIndex - 1], newPages[currentPageIndex]] = [
      newPages[currentPageIndex],
      newPages[currentPageIndex - 1],
    ];
    setPageRestitution(newPages);
    setCurrentPage(newPages[currentPageIndex - 1]);
    setCurrentPageIndex(currentPageIndex - 1);
    dispatch(gameVariablesTemplateActions.setPageRestitution(newPages));
  };

  const moveDown = () => {
    if (currentPageIndex === maxPages - 1) return;
    const newPages = [...pageRestitution];
    [newPages[currentPageIndex + 1], newPages[currentPageIndex]] = [
      newPages[currentPageIndex],
      newPages[currentPageIndex + 1],
    ];
    setPageRestitution(newPages);
    setCurrentPage(newPages[currentPageIndex + 1]);
    setCurrentPageIndex(currentPageIndex + 1);
    dispatch(gameVariablesTemplateActions.setPageRestitution(newPages));
  };

  const handleInputChange = (e: any) => {
    const value = Number(e.target.value);

    if (!value || value < 1 || value > maxPages) return;

    const newIndex = value - 1;
    if (newIndex === currentPageIndex) return;

    const newPages = [...pageRestitution];
    const [movedItem] = newPages.splice(currentPageIndex, 1);
    newPages.splice(newIndex, 0, movedItem);

    setPageRestitution(newPages);
    setCurrentPage(newPages[newIndex]);
    setCurrentPageIndex(newIndex);
    dispatch(gameVariablesTemplateActions.setPageRestitution(newPages));
  };

  const deleteCurrent = () => {
    if (pageRestitution.length === 0) return;

    const newPages = [...pageRestitution].filter((_: any, i: number) => i !== currentPageIndex);
    setPageRestitution(newPages);
    setCurrentPage(newPages[currentPageIndex]);
    setCurrentPageIndex(currentPageIndex);
    dispatch(gameVariablesTemplateActions.setPageRestitution(newPages));

    if (currentPageIndex >= newPages.length) {
      setCurrentPageIndex(newPages.length - 1);
      setCurrentPage(newPages[newPages.length - 1]);
    }
    setOpenModal(false);
  };

  const cancelEdit = () => {
    if (edit) {
      history.push('/admin/game/create-variables/edit');
    } else {
      history.push('/admin/game/create-variables');
    }
    sessionStorage.removeItem('addRestitutionPagePosition');
  };

  return (
    <Layout isaddBackground={true} showOverFlow={true} key={id}>
      <>
        <ModalEditGame
          open={openPublishModal || openExitModal}
          handleClose={handleCloseModal}
          title={valuesBooksTemplate?.titlGame || valuesBooksTemplate?.title || ''}
          message={
            openPublishModal
              ? 'Vous êtes sur le point de publier le jeu'
              : "Êtes-vous sûr de vouloir quitter l'édition du jeu ?"
          }
          onCancel={handleCancelModal}
          onConfirm={handleConfirmModal}
        />
        <Loader open={loading} text={textLoading} />
        <Grid container={true} justifyContent="flex-end">
          <Grid item={true} sm={2} className={classes.section1}>
            <div className={classes.inner}>
              <div className={`${classes.wrapbutton} ${activeIndex === 0 ? 'active' : ''}`}>
                <IconButton
                  aria-label="exit"
                  className={classes.iconButton}
                  onClick={() => {
                    handleButtonClick(0);
                    setOpenExitModal(true);
                  }}>
                  <Move className={classes.icon} />
                </IconButton>
                <div className={classes.tooltipLabel}>Quitter sans sauvegarder</div>
              </div>
              <div className={`${classes.wrapbutton} ${activeIndex === 1 ? 'active' : ''}`}>
                <IconButton
                  aria-label="save"
                  className={classes.iconButton}
                  onClick={() => {
                    handleButtonClick(1);
                    handleSaveGame();
                  }}>
                  <Save className={classes.icon} />
                </IconButton>
                <div className={classes.tooltipLabel}>Sauvegarder comme brouillon</div>
              </div>
              <div className={`${classes.wrapbutton} ${activeIndex === 2 ? 'active' : ''}`}>
                <IconButton
                  aria-label="publish"
                  className={classes.iconButton}
                  onClick={() => {
                    handleButtonClick(2);
                    setOpenPublishModal(true);
                  }}>
                  <Browser className={classes.icon} />
                </IconButton>
                <div className={classes.tooltipLabel}>Publier</div>
              </div>
            </div>
          </Grid>
          <Grid item={true} sm={10} className={classes.section2}>
            <div style={{ padding: '10px 30px', width: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                  <div style={{ marginTop: 10 }}>
                    <Typography variant="h4" className={classes.title2} style={{ color: 'black' }}>
                      Édition de la restitution {valuesVariables?.name || ''}
                    </Typography>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {isEditTitle ? (
                      <TextField
                        ref={refInput}
                        variant="outlined"
                        className={classes.formInput}
                        name="test-name"
                        value={title}
                        onChange={e => handleTitleChange(e.target.value)}
                        placeholder="Titre de la page de restitution"
                        onBlur={() => {
                          const pageRestArray = cloneDeep(valuesVariables.page_restitution);
                          pageRestArray[currentPageIndex]['title'] = title;
                          valuesVariables.page_restitution = pageRestArray;
                          dispatch(gameVariablesTemplateActions.setPageRestitution(pageRestArray));
                          setPageRestitution(pageRestArray);
                          setIsEditTitle(false);
                        }}
                        onKeyDown={handleKeyDownT}
                        autoFocus={true}
                      />
                    ) : (
                      <>
                        <Typography variant="h4" className={classes.title2}>
                          {title || 'Page de restitution sans titre'}
                        </Typography>
                      </>
                    )}
                    <IconButton
                      aria-label="edit-title"
                      style={{ marginLeft: 15 }}
                      onClick={() => setIsEditTitle(!isEditTitle)}>
                      <Border className={classes.icon} />
                    </IconButton>
                    </div>
                </div>

                <div className={classes.containerPageNumber}>
                  <Typography variant="h4" className={classes.title2}>
                    Position dans le sommaire
                  </Typography>
                  <TextField
                    variant="outlined"
                    className={classes.formInputNumber}
                    name="test-name"
                    inputProps={{ min: 1, max: maxPages }}
                    value={currentPageIndex + 1}
                    onChange={handleInputChange}
                  />
                  <div className={classes.containerIconS}>
                    <KeyboardArrowUp
                      onClick={moveUp}
                      className={classes.iconS}
                    />
                    <KeyboardArrowDown
                      onClick={moveDown}
                      className={classes.iconS}
                    />
                  </div>
                </div>

                <div>
                  <Button
                    color="primary"
                    style={{ marginLeft: 40 }}
                    startIcon={<Delete className={classes.iconbig} />}
                    onClick={() => setOpenModal(true)}>
                    <Typography variant="h4" className={classes.title2}>
                      Supprimer la page
                    </Typography>
                  </Button>
                  <SimpleModal
                    open={openModal}
                    handleClose={() => setOpenModal(false)}
                    title="Information"
                    message="Êtes vous sur de vouloir supprimer cette page ?"
                    textClick="Oui"
                    textClose="Non"
                    handleClick={deleteCurrent}
                  />
                </div>

                <div>
                  <Button
                    variant="outlined"
                    className={classes.button}
                    style={{ width: 'auto' }}
                    onClick={() => setOpenModalCancel(true)}>
                    Annuler
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    id="draft-submit"
                    onClick={handleSubmit}
                    className={classes.btnPrimarySticky}
                    style={{ width: 'auto' }}>
                    Valider cette restitution
                  </Button>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>

        <Grid container={true} style={{ background: '#F1F1F1' }}>
          {/* Sommaire des pages de restitution */}
          <Grid item={true} sm={2} className={classes.section3}>
            <div style={{ padding: '15px 15px', height: '90vh', overflowY: 'auto' }}>
              <Typography variant="h6" style={{ marginBottom: 15, fontSize: 14, fontWeight: 700 }}>
                Sommaire de la restitution
              </Typography>

              {pageRestitution.length === 0 && (
                <ItemAddRestitution variableIndex={id} position={0} />
              )}

              {pageRestitution.length > 0 && (
                <>
                  <DragListRestitution
                    variableIndex={id}
                    initialItems={pageRestitution}
                    handlePageToEdit={(page: any, i?: number) => handlePageSelect(page, i)}
                    handleIndex={(index: number) => setCurrentPageIndex(index)}
                    pageSelected={currentPage}
                    handleReorderPages={(reorderedPages: any, newIndex: number) =>
                      handleReorderPages(reorderedPages, newIndex)
                    }
                  />
                  <ItemAddRestitution variableIndex={id} position={pageRestitution.length} />
                </>
              )}
            </div>
          </Grid>

          {/* Zone d'édition de la page courante */}
          <Grid item={true} sm={10} className={classes.section4}>
            {currentPage ? (
              renderModelCondition(currentPage)
            ) : (
              <Typography variant="h5">
                {pageRestitution.length === 0
                  ? 'Cliquez sur + pour ajouter une page de restitution'
                  : 'Sélectionnez une page de restitution'}
              </Typography>
            )}
          </Grid>
        </Grid>

        <Modal
          data-cy="cancel-test-create-modal"
          open={openModalCancel}
          onCancel={() => setOpenModalCancel(false)}
          onConfirm={() => cancelEdit()}
          textCancel="Non"
          title=""
          textValidate="Oui">
          <h3 style={{ color: '#000A8C' }}>Êtes-vous sûr de vouloir annuler les modifications ?</h3>
        </Modal>
      </>
    </Layout>
  );
};

export default EditVariable;
